import { render } from "./MPaging.vue?vue&type=template&id=77d331ae&scoped=true"
import script from "./MPaging.vue?vue&type=script&lang=js"
export * from "./MPaging.vue?vue&type=script&lang=js"

import "./MPaging.vue?vue&type=style&index=0&id=77d331ae&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d331ae"]])

export default __exports__